import React, { forwardRef } from 'react';
import { DateSelect } from 'zarm';
import { formatDate, formatDays } from './_util';

import UItem from '../item';
import { clearObj } from '../../utils/tools';
import { BaseWidgetProps } from '../../utils/type';

export interface DateProps extends BaseWidgetProps {
  placeholder?: string;
  mode?: 'year' | 'month' | 'date' | 'time' | 'datetime';
  min?: string;
  max?: string;
  format?: string;
  minuteStep?: number;
  defaultValue?: any;
  value?: any,
  readonly?: boolean;
  readOnly?: boolean;
  className?: string;
  allowClear?: boolean;
  disabled?: boolean;
  validate?: {
    rules: any[];
  };
}

function handleFormat(fmt: string = 'yyyy-MM-dd') {
  if (fmt.toLowerCase() === 'yyyy-mm-dd') {
    return 'yyyy-MM-dd';
  }
  return fmt;
}

const TempDateSelect = forwardRef((props: DateProps, ref: any) => {
  const { onChange, prefixCls, readOnly, ...otherProps } = props;
  const { value, defaultValue } = otherProps || {};
  const format = handleFormat(otherProps.format);

  // 只读
  if (readOnly) {
    return (
      <div className={`${prefixCls}-readOnly`}>
        {value || defaultValue}
      </div>
    );
  }

  if (value || defaultValue) {
    const valueStr = value ? value.toString().replace(/-/g, '/') : value;
    const defaultValueStr = defaultValue ? defaultValue.toString().replace(/-/g, '/') : defaultValue;
  
    // tips: ios new Date 解析 202205 格式报错 Invalid Date，需要补全日期
    let finalValue = valueStr || defaultValueStr;
    if (props.format === 'yyyy-MM' && finalValue.length === 7) {
      finalValue = `${valueStr}/01`;
    }
    
    otherProps.value = new Date(finalValue);
  }

  return (
    <DateSelect
      {...otherProps}
      ref={ref}
      className={prefixCls}
      onOk={(dateValue) => {
        onChange && onChange(formatDate(dateValue, format));
      }}
    />
  );
});

// 表单 日期组件
function UDate(props: DateProps) {
  const {
    value,
    defaultValue,
    placeholder,
    mode = 'date',
    min,
    max,
    format,
    minuteStep,
    className,
    readOnly,
    readonly,
    allowClear,
    _crengine,
    prefixCls = 'crm-date',
    disabled,
    ...rest
  } = props;

  // 子项内容改变的时候进行数据更新
  function onValueChange(e: any) {
    const { onChange, ...otherProps } = props;
    if (!onChange) return;
    onChange({
      ...otherProps,
      value: e,
    });
  }

  const dateProps = clearObj({
    value: formatDays(value),
    defaultValue: formatDays(defaultValue),
    placeholder,
    mode,
    // props min: ''
    min: (formatDays(min) || '1900-01-01'),
    max: (formatDays(max) || '2023-01-01'),
    format: handleFormat(format),
    minuteStep,
    allowClear,
    _crengine,
    prefixCls,
    disabled,
    readOnly: readOnly || readonly,
    onChange: onValueChange,
  });

  const { form } = _crengine || {};

  // 如果wform存在 则去除input组件的某些属性
  if (form) {
    delete dateProps.value;
    delete dateProps.defaultValue;
    delete dateProps.onChange;
  }

  return (
    <UItem
      {...rest}
      itemType="date"
      _crengine={_crengine}
      initialValue={formatDays(value || defaultValue)}
      onChange={(e) => onValueChange(e)}
    >
      <TempDateSelect {...dateProps} />
    </UItem>
  );
}

export default UDate;

export const DateItem = TempDateSelect;
